import styled, { css } from 'styled-components';

import { Button } from 'components/Button';
import device from 'utils/device';

type Props = {
  order: string;
};

export const Container = styled.div<Props>`
  padding-top: 64px;

  @media ${device.isDesktop}, ${device.isTablet} {
    display: flex;
    justify-content: ${props => (props.order === 'ascending' ? 'flex-end' : 'flex-start')};
    align-items: flex-end;
    flex-grow: 1;
    flex-direction: ${props => (props.order === 'ascending' ? 'row' : 'row-reverse')};
  }

  @media ${device.isMobile} {
    display: flex;
    flex-direction: ${props => (props.order === 'ascending' ? 'column-reverse' : 'column')};
    padding-bottom: 12px;
  }

  @media ${device.isDesktop} {
    padding-right: 32px;
  }
`;

const primaryButtonCss = css``;
const secondaryButtonCss = css`
  @media ${device.isMobile} {
    margin-top: 20px;
  }
  @media ${device.isDesktop}, ${device.isTablet} {
    margin-right: 20px;
  }
`;
const tertiaryButtonCss = css`
  @media ${device.isMobile} {
    margin-top: 20px;
  }
  @media ${device.isDesktop}, ${device.isTablet} {
    margin-right: 20px;
  }
`;

export const NavButton = styled(Button)`
  ${props => {
    const { buttonType } = props;
    switch (buttonType) {
      case 'secondary':
        return secondaryButtonCss;
      case 'tertiary':
        return tertiaryButtonCss;
      case 'primary':
      default:
        return primaryButtonCss;
    }
  }}
`;
